import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  selectPrefix,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setreportsFromDate,
  setreportsTodate,
} from "../../utility/Redux/profile";
import { GetItemWisePurchaseSummary } from "./func";
import { selectToken } from "../../utility/Redux/security";
import AccountMasterHelp from "../../help/listAccountMasterHelp";
import {
  DepartmentWiseColumns,
  ItemwisePurchaseColumns,
  OutletWiseColumns,
} from "./columns";
import Footer from "./footer";
import { PrintButton } from "../../utility/component/buttons";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import GeniusTableReports from "../../utility/component/geniusComponents/geniusTableData";
import { PrintItemwisePurchaseColumns } from "./printColumns";
import GeniusTableForReports from "./printReport";
import IsLocalData from "../../utility/component/isLocalData";
import FromToDateMobile from "../../utility/component/fromToDateMobile";
import { SectionWiseSale } from "../../billing/comp";
import { FromToDate } from "../../utility/component/fromToDate";
import { Pagination } from "@mui/material";
import NewPrintReport from "../../utility/component/datagrid/newPrintReport";
import { FormatNumber2 } from "../../utility/functions/formatNumber";
import { CallAPIPromise } from "../../billing/common";
import {
  setAlertWithTitle,
  setSpinnerLoading,
} from "../../utility/Redux/modal";

const DepWiseRecieve = () => {
  const prefix = useSelector(selectPrefix);
  const [purchaseList, setPurchaseList] = useState([]);
  const fromDate = useSelector(selectreportFromDate);
  const ToDate = useSelector(selectreportToDate);
  const width = useSelector(selectWidth);
  const [secName, setSecName] = useState("");
  const [fullItemWiseReport, setFullItemWiseReport] = useState([]);
  const [getSectionData, setSectionData] = useState({
    table_prefix: prefix,
    FDATE: moment(fromDate).format("YYYY-MM-DD"),
    TDATE: moment(ToDate).format("YYYY-MM-DD"),
    DEP_NAME: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState(1);
  const columns = ItemwisePurchaseColumns(width);
  const printColumns = PrintItemwisePurchaseColumns(width);
  const cols = DepartmentWiseColumns(width);
  const outletWiseCol = OutletWiseColumns(width);
  const [partyHelpStatus, setPartyHelpStatus] = useState(false);
  const [summaryList, setSummaryList] = useState([]);
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const okButton = () => {
    setSummaryList([]);
    setPurchaseList([]);
    setSecName("");
    setSelectedType("Department");
    const additionalData = {
      table_prefix: prefix,
      FDATE: moment(fromDate).format("YYYY-MM-DD"),
      TDATE: moment(ToDate).format("YYYY-MM-DD"),
      DEP_NAME: "",
      currentPage: 1,
    };

    GetItemWisePurchaseSummary(
      additionalData,
      token,
      dispatch,
      setPurchaseList,
      setFullItemWiseReport,
      setSummaryList,
      settotalPages,
      setCurrentPage
    );
  };

  useEffect(() => {
    setSectionData((e) => {
      return {
        ...e,
        FDATE: moment(fromDate).format("YYYY-MM-DD"),
        TDATE: moment(ToDate).format("YYYY-MM-DD"),
        DEP_NAME: secName,
      };
    });
  }, [fromDate, ToDate, secName]);

  const navigate = useNavigate();
  const [sectionWiseSaleStatus, setSectionWiseSaleStatus] = useState(false);
  const [selectedType, setSelectedType] = useState("Department");
  const printRef = useRef();
  const printRefSection = useRef();
  const thermalPrintRef = useRef();
  const thermalPrintRefSection = useRef();
  const [selectedPrintOption, setSelectedPrintOption] = useState("print");
  const [selectedPrintOptionSection, setSelectedPrintOptionSection] =
    useState("print");

  const handlePrint = useReactToPrint({
    pageStyle: `
    @page {
      size: landscape;
    }
  `,
    content: () =>
      selectedPrintOption === "print"
        ? printRef.current
        : thermalPrintRef.current,
    onAfterPrint: () => {
      setSelectedPrintOption("print");
    },
  });

  const handlePrint2 = useReactToPrint({
    pageStyle: `
    @page {
      size: portrait;
    }
  `,
    content: () =>
      selectedPrintOptionSection === "print"
        ? printRefSection.current
        : thermalPrintRefSection.current,
    onAfterPrint: () => {
      setSelectedPrintOptionSection("print");
    },
  });

  useEffect(() => {
    const callback = (details, data) => {
      setSectionData(details[0]);
      setSummaryList(data);
      dispatch(setreportsFromDate(details[0].FDATE));
      dispatch(setreportsTodate(details[0].TDATE));
    };
    const elseFunc = () => {};
    IsLocalData("dep_wise_recieve_department", callback, elseFunc);
  }, []);

  useEffect(() => {
    const callback = (details, data) => {
      setFullItemWiseReport(data);
      setPurchaseList(data);
      dispatch(setreportsFromDate(details[0].FDATE));
      dispatch(setreportsTodate(details[0].TDATE));
    };
    const elseFunc = () => {};
    IsLocalData("dep_wise_recieve", callback, elseFunc);
  }, []);

  return (
    <div className=" bg-white flex flex-col h-full  overflow-y-scroll ">
      <div className="flex w-full h-full">
        {width > 1000 ? (
          <div
            className="flex flex-col  pl-3 py-3 pr-0"
            style={{
              width: cols.reduce((acc, row) => acc + Number(row.width), 0) + 25,
              height: "100%",
            }}
          >
            <div className="text-sm mb-2 w-full">
              <div className="grid grid-cols-2 gap-2 w-full">
                <div className="bg-[#f09536] p-2 rounded-sm shadow-md flex justify-center">
                  <div className="flex">
                    <input
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedType("Department");
                          dispatch(setSpinnerLoading("Loading"));

                          CallAPIPromise(
                            "/api/receiveStockReport/departmentWiseReceive",
                            {
                              table_prefix: prefix,
                              FDATE: moment(fromDate).format("YYYY-MM-DD"),
                              TDATE: moment(ToDate).format("YYYY-MM-DD"),
                              DEP_NAME: "",
                            }
                          )
                            .then((e) => {
                              const res = e.data.data;
                              settotalPages(e.data.pagination.totalPages);
                              setCurrentPage(e.data.pagination.currentPage);
                              setSummaryList(e.data.departmentSummary);
                              if (res[0]) {
                                setPurchaseList(res);

                                setFullItemWiseReport(res);
                              } else {
                                setPurchaseList([]);

                                dispatch(
                                  setAlertWithTitle({
                                    title: "Alert",
                                    msg: "No data found",
                                  })
                                );
                              }
                            })
                            .finally(() => {
                              dispatch(setSpinnerLoading(false));
                            });
                        }
                      }}
                      type="radio"
                      checked={selectedType === "Department"}
                    />
                    <div className="ml-2">Department</div>
                  </div>
                </div>

                <div className="bg-[#ef750f] p-2 rounded-sm shadow-md flex justify-center">
                  <div className="flex">
                    <input
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedType("Outlet");
                          dispatch(setSpinnerLoading("Loading"));
                          CallAPIPromise(
                            "/api/receiveStockReport/outletWiseReceive",
                            {
                              table_prefix: prefix,
                              FDATE: moment(fromDate).format("YYYY-MM-DD"),
                              TDATE: moment(ToDate).format("YYYY-MM-DD"),
                              OUTLET_NAME: "",
                            }
                          )
                            .then((e) => {
                              const res = e.data.data;
                              settotalPages(e.data.pagination.totalPages);
                              setCurrentPage(e.data.pagination.currentPage);
                              setSummaryList(e.data.outletSummary);
                              if (res[0]) {
                                setPurchaseList(res);

                                setFullItemWiseReport(res);
                              } else {
                                setPurchaseList([]);

                                dispatch(
                                  setAlertWithTitle({
                                    title: "Alert",
                                    msg: "No data found",
                                  })
                                );
                              }
                            })
                            .finally(() => {
                              dispatch(setSpinnerLoading(false));
                            });
                        }
                      }}
                      type="radio"
                      checked={selectedType === "Outlet"}
                    />
                    <div className="ml-2">Outlet</div>
                  </div>
                </div>
              </div>
            </div>
            <GeniusTableReports
              onRowClick={(e) => {
                const data = {
                  table_prefix: prefix,
                  FDATE: moment(fromDate).format("YYYY-MM-DD"),
                  TDATE: moment(ToDate).format("YYYY-MM-DD"),
                  DEP_NAME: e.values.DEP_NAME,
                };
                setSecName(e.values.DEP_NAME);

                GetItemWisePurchaseSummary(
                  data,
                  token,
                  dispatch,
                  setPurchaseList,
                  setFullItemWiseReport,
                  setSummaryList,
                  settotalPages,
                  setCurrentPage
                );
              }}
              columns={selectedType === "Department" ? cols : outletWiseCol}
              data={summaryList}
              footer={<Footer columns={cols} rows={summaryList} />}
            />

            <div className="mt-2">
              <PrintButton onClick={handlePrint2} />
            </div>
          </div>
        ) : null}
        <div
          style={{
            width:
              width > 1000
                ? width -
                  (cols.reduce((acc, row) => acc + Number(row.width), 0) + 40)
                : "100%",
          }}
          className=" flex flex-col p-3 "
        >
          <div className="w-full">
            {width > 1280 ? (
              <FromToDate
                partyData={{
                  NAME: getSectionData.NAME,
                }}
                hideReset={true}
                onPrintClick={handlePrint}
                submit={okButton}
              />
            ) : (
              <FromToDateMobile
                partyData={{
                  NAME: getSectionData.NAME,
                }}
                partyClear={() => {
                  setSecName("");
                  setSectionData("");
                  setPurchaseList([]);
                  setSummaryList([]);
                }}
                onPrintClick={handlePrint}
                onPartyMasterSearchClick={(e) => setPartyHelpStatus(true)}
                submit={okButton}
                sectionHelp={
                  <SectionWiseSale
                    normaltext={true}
                    section={secName}
                    setIsSectionDraweropen={setSectionWiseSaleStatus}
                    isSectionDrawerOpen={sectionWiseSaleStatus}
                    data={
                      <GeniusTableReports
                        onRowClick={(e) => {
                          const data = {
                            table_prefix: prefix,
                            FDATE: moment(fromDate).format("YYYY-MM-DD"),
                            TDATE: moment(ToDate).format("YYYY-MM-DD"),
                            CUSTOMER_MOBILE: getSectionData.NAME,
                            DEP_NAME: e.values.DEP_NAME,
                          };
                          setSectionWiseSaleStatus(false);
                          setSecName(e.values.DEP_NAME);

                          GetItemWisePurchaseSummary(
                            data,
                            token,
                            dispatch,
                            setPurchaseList,
                            setFullItemWiseReport,
                            setSummaryList,
                            settotalPages,
                            setCurrentPage
                          );
                        }}
                        columns={cols}
                        data={summaryList}
                        footer={() => console.log("hi")}
                      />
                    }
                  />
                }
              />
            )}
          </div>
          {width > 1280 ? (
            <input
              className=" h-[30px] outline-none text-sm"
              readOnly
              value={secName}
            />
          ) : (
            <div className="h-[30px]" />
          )}
          <div
            style={{
              height: `calc(100% - 150px)`,
              width: "100%",
            }}
            className=" mb-2 "
          >
            {purchaseList[0] ? (
              <GeniusTableReports
                columns={columns}
                data={purchaseList}
                footer={<Footer columns={columns} rows={purchaseList} />}
              />
            ) : (
              <div className="border rounded-sm h-full flex text-sm text-gray-500 items-center justify-center">
                No Records Found
              </div>
            )}
          </div>
          <div className="flex justify-end">
            <Pagination
              count={totalPages}
              page={currentPage}
              sx={{
                "& .MuiPaginationItem-root": {
                  color: "#000",
                  backgroundColor: "#f3f4f6", // light gray
                  borderRadius: "8px", // rounded rectangle
                  margin: "0 4px",
                  minWidth: "36px",
                  height: "36px",
                },
            
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: "#e5e7eb",
                },
            
                "& .Mui-selected": {
                  backgroundColor: "#000 !important",
                  color: "#fff !important",
                },
            
                "& .Mui-selected:hover": {
                  backgroundColor: "#000",
                },
              }}
              onChange={(e, p) => {
                const additionalData = {
                  table_prefix: prefix,
                  FDATE: moment(fromDate).format("YYYY-MM-DD"),
                  TDATE: moment(ToDate).format("YYYY-MM-DD"),
                  DEP_NAME: secName,
                  currentPage: p,
                };

                GetItemWisePurchaseSummary(
                  additionalData,
                  token,
                  dispatch,
                  setPurchaseList,
                  setFullItemWiseReport,
                  setSummaryList,
                  settotalPages,
                  setCurrentPage
                );
              }}
            />
          </div>
        </div>
      </div>
      <AccountMasterHelp
        onRowClick={(e) => {
          setSectionData((c) => {
            return {
              ...c,
              NAME: e.row.NAME,
            };
          });

          setPartyHelpStatus(false);
        }}
        status={partyHelpStatus}
        onClose={() => {
          setPartyHelpStatus(false);
        }}
      />

      {!secName && (
        <div
          style={{
            display: "none",
          }}
        >
          <div ref={printRef}>
            <GeniusTableForReports
              marginTop={"10px"}
              title={"Department Wise Issue Report"}
              headerWidth={true}
              fromDate={fromDate}
              ToDate={ToDate}
              data={
                purchaseList[0]
                  ? purchaseList.map((p) => {
                      return {
                        ...p,
                        RATE: FormatNumber2(p.RATE),
                        IAMOUNT: FormatNumber2(p.IAMOUNT),
                        RAMOUNT: FormatNumber2(p.RAMOUNT),
                      };
                    })
                  : fullItemWiseReport.map((p) => {
                      return {
                        ...p,
                        RATE: FormatNumber2(p.RATE),
                        IAMOUNT: FormatNumber2(p.IAMOUNT),
                        RAMOUNT: FormatNumber2(p.RAMOUNT),
                      };
                    })
              }
              columns={printColumns}
              filteredData={
                secName
                  ? [
                      {
                        DEP_NAME: secName,
                        GTOTAL: 21945.64,
                      },
                    ]
                  : summaryList
              }
            />
          </div>
        </div>
      )}
      {secName && (
        <div
          style={{
            display: "none",
          }}
        >
          <div ref={printRef}>
            <GeniusTableForReports
              title={"Department Wise Issue Report"}
              marginTop={"10px"}
              fromDate={fromDate}
              ToDate={ToDate}
              headerWidth={true}
              data={
                purchaseList[0]
                  ? purchaseList.map((p) => {
                      return {
                        ...p,
                        RATE: FormatNumber2(p.RATE),
                        IAMOUNT: FormatNumber2(p.IAMOUNT),
                        RAMOUNT: FormatNumber2(p.RAMOUNT),
                      };
                    })
                  : fullItemWiseReport.map((p) => {
                      return {
                        ...p,
                        RATE: FormatNumber2(p.RATE),
                        IAMOUNT: FormatNumber2(p.IAMOUNT),
                        RAMOUNT: FormatNumber2(p.RAMOUNT),
                      };
                    })
              }
              columns={printColumns}
              filteredData={
                secName
                  ? [
                      {
                        DEP_NAME: secName,
                        GTOTAL: 21945.64,
                      },
                    ]
                  : summaryList
              }
            />
          </div>
        </div>
      )}

      <div
        style={{
          display: "none",
        }}
      >
        <div ref={printRefSection}>
          <NewPrintReport
            details={[
              {
                name: "From Date",
                value: moment(fromDate).format("DD/MM/YYYY"),
              },
              {
                name: "To Date",
                value: moment(ToDate).format("DD/MM/YYYY"),
              },
            ]}
            title={
              selectedType === "Department"
                ? "Department Wise Issue"
                : "Outlet Wise Issue"
            }
            data={summaryList}
            columns={selectedType === "Department" ? cols : outletWiseCol}
            footer={
              <Footer
                isFeilds={
                  <div className="flex justify-end text-sm mt-2">
                    <div>
                      <div className="flex ">
                        <div className="font-semibold w-[160px] text-right ">
                          Grand Total :
                        </div>
                        <div className="ml-2 flex flex-1 justify-end ">
                          {FormatNumber2(
                            summaryList.reduce(
                              (acc, row) => acc + Number(row.AMOUNT),
                              0
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                columns={cols}
                rows={summaryList}
              />
            }
          />
        </div>
      </div>
    </div>
  );
};

export default DepWiseRecieve;
